import {
  FiletypeCsv,
  FiletypeDoc,
  FiletypeDocx,
  FiletypeGif,
  FiletypeJpg,
  FiletypeMp3,
  FiletypeMp4,
  FiletypePdf,
  FiletypePng,
  FiletypePpt,
  FiletypePptx,
  FiletypeTxt,
  FiletypeXls,
  FiletypeXlsx,
  FileZip,
  FileX
} from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';

import { DownloadOutlined } from '@ant-design/icons';
import { Button, List, Skeleton } from 'antd';

import { useGetLessonsQuery } from '@/services/lesson';
import { API_V4_BASE_URL } from '@/settings';
import styled, { css, StyledProp } from '@/styled';

const Files = ({ className }: StyledProp) => {
  const { id } = useParams();
  const lesson = useGetLessonsQuery(id);

  const iconMapper: Record<string, JSX.Element> = {
    csv: <FiletypeCsv size={48} />,
    doc: <FiletypeDoc size={48} />,
    docx: <FiletypeDocx size={48} />,
    jpg: <FiletypeJpg size={48} />,
    jpeg: <FiletypeJpg size={48} />,
    mp3: <FiletypeMp3 size={48} />,
    mp4: <FiletypeMp4 size={48} />,
    pdf: <FiletypePdf size={48} />,
    png: <FiletypePng size={48} />,
    ppt: <FiletypePpt size={48} />,
    pptx: <FiletypePptx size={48} />,
    txt: <FiletypeTxt size={48} />,
    xls: <FiletypeXls size={48} />,
    xlsx: <FiletypeXlsx size={48} />,
    gif: <FiletypeGif size={48} />,
    zip: <FileZip size={48} />
  };
  return (
    <section className={className}>
      <List
        itemLayout='horizontal'
        locale={{ emptyText: 'Sem Arquivos' }}
        dataSource={lesson?.data?.lesson_files}
        renderItem={files => (
          <Skeleton avatar title={false} loading={lesson?.isFetching}>
            <List.Item className='lineItem' key={files.id_lesson_file}>
              <List.Item.Meta avatar={iconMapper[files.extension] ?? <FileX size={48} />} title={files.title} />
              <div className='actions'>
                <Button
                  className='buttonDefault downloadFile'
                  icon={<DownloadOutlined />}
                  href={`${API_V4_BASE_URL}${files.file_name}`}
                  target='_blank'
                  download
                  rel='noreferrer'
                >
                  Baixar
                </Button>
              </div>
            </List.Item>
          </Skeleton>
        )}
      />
    </section>
  );
};

export default styled(Files)(
  ({ theme }) => css`
    .actions {
      gap: ${theme.space.spacing(4)};
      display: flex;
      padding-left: 12px;
    }

    .buttonDefault {
      align-items: center;
      padding: ${theme.space.spacing(2, 4)};

      border-radius: 4px;
      border: 1px solid;
    }

    .downloadFile {
      border: none;
      width: 99px;
      height: 40px;
      background: ${theme.variables.contentDownloadFileButton.background};
      color: ${theme.colorTextBase};
    }

    .lineItem {
      padding: ${theme.space.spacing(6, 0)};
      border-color: ${theme.variables.dividerColor};
    }

    .ant-list-item .ant-list-item-meta .ant-list-item-meta-title {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      margin-bottom: 0;
    }

    ${theme.breakpoints.down('lg')} {
      .lineItem {
        flex-direction: column;
        align-items: normal;
      }

      .actions {
        flex-direction: column;

        button {
          width: 100%;
        }
      }

      .ant-list-item-meta {
        margin-bottom: ${theme.space.spacing(6)};
      }
    }

    .btnDonwloadAllFiles {
      height: 40px;
      background: ${theme.palette.brand.primary};
      border-color: ${theme.palette.brand.primary};
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: ${theme.palette.alpha(theme.palette.gray[12], 0.85)};
    }

    .btnDonwloadAllFiles:hover {
      color: ${theme.palette.alpha(theme.palette.gray[12], 0.85)};
    }
  `
);
